module.exports = __webpack_public_path__ + "static/media/20170105_Altendorf_WA_6_Brochure_gb.9f56b742.pdf";